import type { IRecordTypeDefinition, IRecordTypeOverride } from '@platform/core/types';
import { builderViewKeys, pageViewKeys, standardViewKeys } from './builderViewKeys';
import type { IBuilderViewRow } from './IBuilderViewRow';
import { viewsOf } from './patchViews';

/**
 * «Подання записів» конструктора (прототип v4 bViews, 15 подань): стандартні — за `views.enabled`; власні (бібліотека, за напрямами,
 * трасування…) — за `views.custom`, перемикаються, лише якщо тип має таке подання (опубліковане чи з налаштуваннями); огляд і поради —
 * сторінки модуля, не перемикаються. Останнє увімкнене подання вимкнути не можна. Чиста функція.
 */
export function builderViewRows(rt: IRecordTypeDefinition, published: IRecordTypeDefinition | undefined, patch: IRecordTypeOverride): IBuilderViewRow[] {
  const { enabled, custom } = viewsOf(rt, patch);
  const own = new Set([...(published?.views.custom ?? []), ...(rt.views.custom ?? []), ...Object.keys(rt.views.settings ?? {})]);
  const total = enabled.length + custom.length;
  return builderViewKeys.map((key) => {
    const page = pageViewKeys.includes(key);
    const standard = (standardViewKeys as readonly string[]).includes(key);
    const on = !page && (standard ? enabled.includes(key) : custom.includes(key));
    const available = page ? false : standard || own.has(key);
    return { key, on, page, disabled: !available || (on && total <= 1) };
  });
}

/** Варіанти «Типового подання»: увімкнені подання в порядку переліку конструктора, далі інші власні. Чиста функція. */
export function defaultViewChoices(rt: IRecordTypeDefinition, patch: IRecordTypeOverride): string[] {
  const { enabled, custom } = viewsOf(rt, patch);
  const on = new Set([...enabled, ...custom]);
  return [...builderViewKeys.filter((k) => on.has(k)), ...[...on].filter((k) => !builderViewKeys.includes(k))];
}
